import { HoverableLinkSizes } from '@paywithextend/components'
import React from 'react'
import ResourceCenterLink from 'src/components/ResourceCenterLink/ResourceCenterLink'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'

interface UnavailableOptionTooltipProps {
  className?: string
  openLeft: boolean
}

const UnavailableOptionTooltip: React.FC<UnavailableOptionTooltipProps> = (
  props,
): React.ReactElement => {
  return (
    <Tooltip className={props.className} openLeft={props.openLeft}>
      <p>
        <Trns
          source={
            'This feature is not currently supported for your account type. To enable this feature, contact us via our ${resourceCenter}.'
          }
          expressions={{
            resourceCenter: (
              <ResourceCenterLink size={HoverableLinkSizes.Small} />
            ),
          }}
        />
      </p>
    </Tooltip>
  )
}

export default UnavailableOptionTooltip
